import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { OCC_USER_ID_CURRENT, Product, ProductScope, UserIdService } from '@spartacus/core';
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { map, Observable, of, Subscription } from 'rxjs';

@Component({
  selector: 'product-price',
  templateUrl: './product-price.component.html',
  styleUrl: './product-price.component.scss',
  standalone: false,
})
export class ProductPriceComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';
  @Input() InProduct$?: Observable<Product>;
  @Input() lazyPrice = false;

  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  outlets = ProductDetailOutlets;
  subscription = new Subscription();

  constructor(
    protected currentProductService: CurrentProductService,
    private userIdService: UserIdService,
  ) {}

  ngOnInit(): void {
    this.checkInputs();
    this.checkProduct();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkInputs() {
    this.subscription.add(
      this.InProduct$?.subscribe(product => {
        this.product$ = of(product);
      }),
    );
  }

  checkProduct() {
    this.subscription.add(
      this.product$.subscribe(product => {
        this.hostClass = product?.discontinued ? 'product-discontinued d-none' : '';
      }),
    );
  }
}
